import React from 'react';
import { Link } from 'react-router-dom';
import AquilaImage from './assets/Aquila Safari.jpg';

function AquilaSafariPage() {
  return (
    <div className="tour-detail-page">
      <section className="hero-subpage aquila-safari-hero">
        <div className="hero-content">
          <h1>Aquila Private Game Reserve Safari</h1>
          <p>A thrilling Big 5 safari experience conveniently close to Cape Town.</p>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">The Big 5 Await at Aquila</h2>
          <div className="content-intro">
            <img src={AquilaImage} alt="Aquila Safari" className="tour-main-image" />
            <p>Embark on an unforgettable journey to Aquila Private Game Reserve, a malaria-free conservation area home to Africa's magnificent Big 5: lion, leopard, elephant, rhino, and buffalo. Ebamba Travel & Tours arranges day trips and overnight stays, providing an authentic safari adventure just a couple of hours from Cape Town.</p>
            <p>Aquila is dedicated to wildlife conservation and rehabilitation. Your visit contributes directly to these efforts while you enjoy expertly guided game drives, witness incredible wildlife, and immerse yourself in the beauty of the Karoo landscape.</p>
          </div>

          <h3 className="text-center mt-5">What to Expect at Aquila Safari</h3>
          <div className="expect-grid">
            <div className="expect-item">
              <i className="fas fa-truck-monster"></i>
              <h4>Guided Game Drives</h4>
              <p>Enjoy exhilarating 4x4 game drives led by experienced rangers, sharing insights into the wildlife and ecosystem.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-paw"></i>
              <h4>Big 5 & More</h4>
              <p>Opportunities to spot the Big 5, along with giraffes, zebras, hippos, and a rich variety of birdlife.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-utensils"></i>
              <h4>Fine Dining</h4>
              <p>Savour delicious buffet meals, often featuring local South African cuisine, prepared with fresh ingredients.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-umbrella-beach"></i>
              <h4>Relaxation Facilities</h4>
              <p>Access to swimming pools, curio shops, and stunning viewing decks to relax between activities.</p>
            </div>
          </div>

          <h3 className="text-center mt-5">Hear From Our Happy Adventurers</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"Aquila was absolutely amazing! We saw four of the Big 5 on our day trip, and our guide was so passionate. Ebamba made the booking process effortless."</p>
              <span>– Sophia M. from Canada</span>
            </div>
            <div className="testimonial-card">
              <p>"A wonderful experience. The reserve is beautiful, the staff are friendly, and the game drives were incredible. Highly recommend Ebamba for an Aquila visit!"</p>
              <span>– Ben C. from UK</span>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="btn btn-primary large-btn tour-btn">Plan Your Aquila Safari</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AquilaSafariPage;
